var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panels',{attrs:{"accordion":"","focusable":""}},_vm._l((_vm.activitiesList),function(ref,i){
var node = ref.node;
return _c('v-expansion-panel',{key:i},[_c('v-expansion-panel-header',[_vm._v(_vm._s(node.name))]),_c('v-expansion-panel-content',{staticClass:"mt-2"},[_c('span',{domProps:{"innerHTML":_vm._s(node.description)}})])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }